import { attrs as editable } from 'storyloco'

interface Section {
	anchor?: string
	padding_top?: string | number
	padding_bottom?: string | number
}

/**
 * Spread onto a block's root: storyloco's attributes, which wire it up for the site editor and give it
 * its anchor as an `id`, and its padding as the custom properties the block's styles read
 */
export function attrs<T extends Section>(blok: T & { _uid?: string; _editable?: string }) {
	const { padding_top, padding_bottom } = blok
	const top = padding_top ? `--padding-top: var(--s-${padding_top});` : ''
	const bottom = padding_bottom ? `--padding-bottom: var(--s-${padding_bottom});` : ''
	return { ...editable(blok), style: top + bottom || undefined }
}
